export type JokerPageRedirect = {
  redirect: { destination: string; permanent: boolean }
  errors?: unknown[]
}

export type JokerPageNotFound = {
  notFound: true
  errors?: unknown[]
}

export const isJokerPageRedirect = (value: unknown): value is JokerPageRedirect =>
  Boolean(
    value &&
      typeof value === 'object' &&
      'redirect' in value &&
      (value as { redirect?: unknown }).redirect
  )

export const isJokerPageNotFound = (value: unknown): value is JokerPageNotFound =>
  Boolean(
    value &&
      typeof value === 'object' &&
      'notFound' in value &&
      (value as { notFound?: unknown }).notFound === true
  )

export const isJokerPageResolution = (value: unknown): boolean =>
  isJokerPageRedirect(value) || isJokerPageNotFound(value)
